import React, { useState } from "react";
import { motion } from "framer-motion";
import { Collapse, Divider, makeStyles } from "@material-ui/core";
import downArrow from "../../../images/v4/aiPage/icons/downArrow.svg";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  scrollableCards: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    marginTop: "64px",
    "@media only screen and (max-width: 600px)": {
      marginTop: "24px",
    },
  },
  scrollableCard: {
    cursor: "pointer",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    borderRadius: "18px 18px 0 0",
    padding: "40px 32px",
    "&:last-child": {
      borderRadius: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      padding: "20px",
    },
    // "&:not(:first-child)": {
    //   bottom: "-10px",
    // },
  },
  scrollableCardInnerLeft: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "20px",
    "& .innerRight": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  scrollableCardInnerRight: {
    width: "50%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        marginTop: "20px",
      },
    },
  },
  body: {
    "& p": {
      marginTop: "32px",
      "@media only screen and (max-width: 600px)": {
        marginTop: "12px",
      },
    },
  },
  cardsSection: {
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
    },
  },
}));

const CardAccordian = ({
  cardsData,
  background,
  heading,
  desc,
  backgroundImage,
  light,
}) => {
  const classes = useStyles();
  const [activeAccordian, setActiveAccordian] = useState(0);
  return (
    <section
      className={classes.cardsSection}
      style={{
        background: background,
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="container">
        <div className="centerContainer">
          <motion.h2
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={clsx(
              "font-wix-semibold font-56",
              light ? "font-white" : "font-black1"
            )}
          >
            {heading}
          </motion.h2>
          <motion.p
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={clsx(
              "font-wix-regular font-20 font-black1",
              light ? "font-white" : "font-black1"
            )}
          >
            {desc}
          </motion.p>
        </div>
        <div className={classes.scrollableCards}>
          {cardsData?.map((card, index) => (
            <motion.div
              onClick={() =>
                setActiveAccordian(index === activeAccordian ? -1 : index)
              }
              whileInView={{ opacity: [0, 1], y: [50, 0] }}
              transition={{ duration: 1, delay: index * 0.01 }}
              className={classes.scrollableCard}
              style={{
                background: card.background,
                bottom: `${15 * index}px`,
                paddingBottom:
                  activeAccordian === index
                    ? index === cardsData.length - 1
                      ? "0"
                      : "15px"
                    : "40px",
              }}
            >
              <div className={classes.scrollableCardInnerLeft}>
                <div className="innerLeft">
                  <p className="font-wix-semibold font-white font-24">
                    {" "}
                    {index + 1}{" "}
                  </p>
                </div>
                <div className="innerRight">
                  <p className="font-wix-semibold font-white font-24">
                    {card.title}
                  </p>
                  <Collapse
                    className={classes.body}
                    in={activeAccordian === index}
                  >
                    <p className="font-18 font-wix-regular font-white">
                      {card.text}
                    </p>
                  </Collapse>
                </div>
              </div>
              <div className={classes.scrollableCardInnerRight}>
                {activeAccordian === index && (
                  <motion.img
                    initial={{ opacity: 1, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: 0 }}
                    src={card.img}
                    alt={card.alt}
                  />
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardAccordian;
